/* eslint-disable no-param-reassign */
import * as THREE from 'three';
import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { PointCollection } from '../collection';
import { Stage } from '../model';
import * as graphicsLib from '../../graphicLibs/index';
import {
  ALMOST_ZERO, BUILDING_TYPE_MANSION, CONTROL_ACTIONMODE, ITEM_MODE_NO,
} from '../Constants';

/** マンションの手描き入力でグリッド吸着が無効なときの格子(px)。線を滑らかにするための最小単位 */
const MANSION_SKETCH_SNAP_UNIT = 5;

/** 始点と終点がこの距離(px)以内なら、閉じた図形として扱う */
const SKETCH_CLOSE_DISTANCE = 10;

export default class ItemControllerRoomSketch {
  dragImage: Element;

  dotList: marietta.core.Point[] = [];

  endPoint: any;

  floor: number;

  callbackOnComplete: Function;

  callbackOnInterrupt: Function;

  tarLayer: marietta.webcad.layer.FloorLayer;

  public spt: SVGSprite;

  sketch: SVGElement;

  path: string;

  /**
   * コンストラクタ
   */
  constructor() {
    this.initMe();
  }

  onMouseDown = (e) => {
    e.preventDefault();
  };

  /**
   * 初期化
   */
  initMe() {
    this.floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    // 作成する階
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.floor);

    const stage = document.querySelector('#layerGroup');
    if (marietta.webcad.WebCADGlobal.userAgentManager.isPC) {
      stage.addEventListener('mousedown', this.startDrag, { passive: false });
    } else {
      stage.addEventListener('touchstart', this.startDrag, { passive: false });
      stage.addEventListener('touchmove', this.moveDrag, { passive: false });
    }

    // this.updateWallList()

    // ドラッグイメージの作成
    this.dragImage = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.sketch = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.dragImage.setAttribute('id', 'dragImage');
    this.sketch.setAttribute('d', '');
    this.sketch.setAttribute('stroke', '#000000');
    this.sketch.setAttribute('stroke-width', '5');
    this.sketch.setAttribute('fill', 'none');
    this.dragImage.appendChild(this.sketch);
    this.tarLayer.viewObj.appendChild(this.dragImage);

    this.spt = new SVGSprite(this.dragImage);
    marietta.webcad.WebCADGlobal.hideBusy();
  }

  /**
   * ドラッグ開始
   */
  startDrag = (e: MouseEvent & TouchEvent) => {
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      Stage.refreshStageMouse(<any>e);
      e.stopImmediatePropagation();
      e.preventDefault();
    }

    const p = this.spt.localToGlobal(new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY));
    this.path = `M ${p.x} ${p.y} L ${p.x} ${p.y} `;
    //   const snap_unit = 60;
    this.dotList.push(new marietta.core.Point(p.x, p.y));
    this.sketch.setAttribute('d', this.path);
    const stage = document.querySelector('#layerGroup');
    if (ua.isPC) {
      stage.addEventListener('mousemove', this.moveDrag, { passive: false });
      stage.addEventListener('mouseup', this.endDrag, { passive: false });
    } else {
      stage.addEventListener('touchend', this.endDrag, { passive: false });
    }
    ua = null;
  };

  endDrag = (e: MouseEvent & TouchEvent) => {
    e.stopPropagation();
    const stage = document.querySelector('#layerGroup');
    stage.removeEventListener('mousemove', this.moveDrag);
    stage.removeEventListener('mouseup', this.endDrag);
    stage.removeEventListener('touchend', this.endDrag);
    // let pts1: marietta.core.Point[] = marietta.webcad.util.LineSimplify.simplify(this.dotList, 500 * (1 / marietta.webcad.WebCADGlobal.scaleSize));//100
    // マンションはグリッド吸着が無効なときだけ従来の細かい格子を使う
    const plan = marietta.webcad.WebCADGlobal.webcad2Dmanager;
    const snapUnit = (plan.buildingType === BUILDING_TYPE_MANSION && !plan.isSnap())
      ? MANSION_SKETCH_SNAP_UNIT
      : plan.snapUnitPix;
    // 閉じ判定は吸着前の描画位置で行う。吸着単位が粗くなっても操作感を保つため
    const rawEndDist: number = marietta.core.Point.distance(this.dotList[this.dotList.length - 1], this.dotList[0]);
    this.dotList.forEach((dot) => {
      dot.x = Math.round(dot.x / snapUnit) * snapUnit;
      dot.y = Math.round(dot.y / snapUnit) * snapUnit;
    });

    if (plan.buildingType === BUILDING_TYPE_MANSION) {
      if (rawEndDist > 0 && rawEndDist <= SKETCH_CLOSE_DISTANCE) {
        this.dotList.push(this.dotList[0].clone());
      }
      this.dotList = marietta.webcad.util.LineSimplify.simplify(this.dotList, 150 * (1 / marietta.webcad.WebCADGlobal.scaleSize)); // 100
    } else {
      this.dotList = marietta.webcad.util.LineSimplify.simplify(this.dotList, 50 * (1 / marietta.webcad.WebCADGlobal.scaleSize)); // 100
    }
    const pointsL = this.reArrangePoints(this.dotList);
    if (marietta.core.Point.distance(pointsL[pointsL.length - 1], pointsL[pointsL.length - 2]) <= ALMOST_ZERO) {
      pointsL.splice(1, pointsL.length - 1);
    }
    this.dotList = pointsL;
    this.endMakeShape();
  };

  /**
   * 形状作成の終了
   */
  protected endMakeShape() {
    marietta.webcad.WebCADGlobal.scene = new graphicsLib.Scene();
    let roomList: marietta.webcad.item.Room[] = [];
    let wallList: marietta.webcad.item.WallObject[] = [];
    const selectedItem = String((<HTMLInputElement>document.getElementById('roomInputMenuItems').querySelector('input[type="radio"]:checked')).value);
    const devide:boolean = (selectedItem !== 'col01_01' && selectedItem !== 'bem01_01');
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION && devide) {
      // 現在の階の頂点リストを取得する
      roomList = (marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_ROOM_NO)).getAllChildren();
      const allPointList: any[] = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAllRoomPointList(roomList);

      marietta.webcad.WebCADGlobal.scene = new graphicsLib.Scene();
      if (allPointList.length > 0) {
        allPointList.forEach((pList: any) => {
          marietta.webcad.WebCADGlobal.scene.add(new graphicsLib.objects.ClosePath(pList));
        });
      }

      // 現在の階の建具の情報を足す
      wallList = (marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_WALL_NO)).getAllChildren();
      const wallPointList: any[] = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAllWallPointList(wallList);
      for (let i: number = 0; i < wallPointList.length; i += 1) {
        marietta.webcad.WebCADGlobal.scene.add(new graphicsLib.objects.Line(new THREE.Vector2(wallPointList[i][0].x, wallPointList[i][0].y), new THREE.Vector2(wallPointList[i][1].x, wallPointList[i][1].y)));
      }
    }
    for (let i = 1; i < this.dotList.length; i += 1) {
      marietta.webcad.WebCADGlobal.scene.add(new graphicsLib.objects.Line(new THREE.Vector2(this.dotList[i - 1].x, this.dotList[i - 1].y), new THREE.Vector2(this.dotList[i].x, this.dotList[i].y)));
    }
    const polyList = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.area();
    const branch = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.graph.branch();
    const outerList = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.outer();
    const { points } = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.pointlist;

    const outerPoints = []; // 外側のポイントリスト
    outerList.forEach((outer: number[]) => {
      for (let i = 1; i <= outer.length; i += 1) {
        outerPoints.push({ p1: points[outer[i - 1]], p2: points[outer[i % outer.length]] });
      }
    });

    const targetFloor: marietta.webcad.layer.FloorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor);
    targetFloor.formatLayersNewRoomCreations();

    const areaPoints = [];
    const usedOldRoomIndexes = [];
    // //新しい配列を元に部屋を生成する
    for (let i: number = 0; i < polyList.length; i += 1) {
      if (polyList[i].length >= 3) {
        for (let j = 0; j < polyList[i].length - 1; j += 1) {
          areaPoints.push({ p1: polyList[i][j], p2: polyList[i][j + 1] });
        }
        areaPoints.push({ p1: polyList[i][polyList[i].length - 1], p2: polyList[i][0] });

        let info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          const dotList = marietta.webcad.util.WebCADUtil.convertPointListToRoomDotList(polyList[i]);
          const existingRoomInfo = marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveAreaInfo(roomList, dotList, usedOldRoomIndexes);
          if (existingRoomInfo.info != null) {
            info = existingRoomInfo.info.clone();
            marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveRoomWallInfo(info.globalDotList, dotList);
            info.index = undefined;
            info.x = 0;
            info.y = 0;
            info.dotList = [];
            let dot: marietta.webcad.collection.PointCollection;
            for (let k: number = 0; k < dotList.length; k += 1) {
              dot = new marietta.webcad.collection.PointCollection(dotList[k].x - info.x, dotList[k].y - info.y, dotList[k].wall_type);
              info.dotList.push(dot);
            }
          } else {
            info.x = 0;
            info.y = 0;
            info.id = String((<HTMLInputElement>document.getElementById('roomInputMenuItems').querySelector('input[type="radio"]:checked')).value);
            info.dotList = [];
            let dot: marietta.webcad.collection.PointCollection;
            const defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(info.id);
            for (let k: number = 0; k < dotList.length; k += 1) {
              dot = new marietta.webcad.collection.PointCollection(dotList[k].x - info.x, dotList[k].y - info.y, defaultRoomSetting.wallType);
              info.dotList.push(dot);
            }

            const textPos = new graphicsLib.utility.labelPosition().labelPosition(polyList[i]);
            info.textPosition = new marietta.core.Point(textPos.x, textPos.y);
          }
        } else {
          const dotList = marietta.webcad.util.WebCADUtil.convertPointListToRoomDotList(polyList[i]);
          info.x = dotList[0].x;
          info.y = dotList[0].y;
          info.id = String((<HTMLInputElement>document.querySelector('#roomInputMenuItems input[type="radio"]:checked')).value);
          // アイテム名称
          info.text = marietta.webcad.WebCADGlobal.language === 'jp' ? (<HTMLInputElement>document.querySelector('#roomInputMenuItems input[type="radio"]:checked')).getAttribute('data-item_name') : (<HTMLInputElement>document.querySelector('#roomInputMenuItems input[type="radio"]:checked')).getAttribute('data-item_name_en');
          info.dotList = [];
          const defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(info.id);
          for (let j: number = 0; j < dotList.length; j += 1) {
            const dot = new marietta.webcad.collection.PointCollection(dotList[j].x - info.x, dotList[j].y - info.y, defaultRoomSetting.wallType);
            info.dotList.push(dot);
          }
          // GraphicLibを使用した部屋のテキスト位置の計算
          marietta.webcad.WebCADGlobal.scene = new graphicsLib.Scene();
          if (dotList[0].x !== dotList[dotList.length - 1].x || dotList[0].y !== dotList[dotList.length - 1].y) {
            dotList.push(dotList[0].clone());
          }
          for (let k = 1; k < dotList.length; k += 1) {
            marietta.webcad.WebCADGlobal.scene.add(new graphicsLib.objects.Line(new THREE.Vector2(dotList[k - 1].x, dotList[k - 1].y), new THREE.Vector2(dotList[k].x, dotList[k].y)));
          }
          const polygonList = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.area();
          const textPos = new graphicsLib.utility.labelPosition().labelPosition(polygonList[0]);
          info.textPosition = new marietta.core.Point(textPos.x, textPos.y);
        }
        if (marietta.webcad.util.WebCADUtil.calculateArea(info.dotList) > 0) { marietta.webcad.WebCADGlobal.itemManager.createItem(info); }
      }
    }

    const wallpoints = [];
    if (branch.length > 0) {
      const nodes = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.graph.adjacencyList;

      nodes.forEach((pointList: number[], index: number) => {
        const pos1: THREE.Vector2 = points[index];
        pointList.forEach((pointIndex: number) => {
          if (branch[index] !== -1) {
            if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isSimilarLine({ p1: pos1, p2: points[pointIndex] }, wallpoints) && !marietta.webcad.WebCADGlobal.webcad2Dmanager.isSimilarLine({ p1: pos1, p2: points[pointIndex] }, areaPoints)) {
              let info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
              if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
                info.x = 0;
                info.y = 0;
                info.id = 'wal01_01';
                info.dotList = [new PointCollection(pos1.x, pos1.y), new PointCollection(points[pointIndex].x, points[pointIndex].y)];
                const oldInfo = marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveWallObjectInfo(wallList, info.dotList);
                if (oldInfo != null) {
                  info = oldInfo.clone();
                }
              } else {
                const dotList = [new PointCollection(pos1.x, pos1.y), new PointCollection(points[pointIndex].x, points[pointIndex].y)];
                const cp = marietta.core.Point.interpolate(dotList[0].point, dotList[1].point, 0.5);
                info.x = cp.x;
                info.y = cp.y;
                info.id = 'fit01_01';
                info.width = marietta.core.Point.distance(dotList[0].point, dotList[1].point);
                if (dotList[0].y !== dotList[1].y) {
                  const ang = marietta.core.Point.getAngleBetween(dotList[0].point, dotList[1].point);
                  info.rotation = ang;
                }
              }
              marietta.webcad.WebCADGlobal.itemManager.createItem(info);
              wallpoints.push({ p1: pos1, p2: points[pointIndex] });
            }
          }
        });
      });
    }

    const missingWalls = this.findMissingWall(areaPoints, wallpoints, outerPoints); // 壁リストに含まれていない壁があるかどうかを確認
    if (missingWalls.length > 0) {
      missingWalls.forEach((wall: any) => {
        let info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
          info.x = 0;
          info.y = 0;
          info.id = 'wal01_01';
          info.dotList = [new PointCollection(wall.p1.x, wall.p1.y), new PointCollection(wall.p2.x, wall.p2.y)];
          const oldInfo = marietta.webcad.WebCADGlobal.webcad2Dmanager.retrieveWallObjectInfo(wallList, info.dotList);
          if (oldInfo != null) {
            info = oldInfo.clone();
          }
        } else {
          const dotList = [new PointCollection(wall.p1.x, wall.p1.y), new PointCollection(wall.p2.x, wall.p2.y)];
          const cp = marietta.core.Point.interpolate(dotList[0].point, dotList[1].point, 0.5);
          info.x = cp.x;
          info.y = cp.y;
          info.id = 'fit01_01';
          info.width = marietta.core.Point.distance(dotList[0].point, dotList[1].point);
          if (dotList[0].y !== dotList[1].y) {
            const ang = marietta.core.Point.getAngleBetween(dotList[0].point, dotList[1].point);
            info.rotation = ang;
          }
        }
        marietta.webcad.WebCADGlobal.itemManager.createItem(info);
      });
    }
    marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
    // //スナップリストの作成
    marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    this.clean();
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.continualInput) {
      marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
      const actionMode = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode;
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = actionMode;
    } else {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
      // 部屋種類ラジオボタンのチェックをはずす
      const checkboxes = document.getElementById('roomInputMenuItems').querySelectorAll('input[type="radio"]');
      for (let i = 0; i < checkboxes.length; i += 1) {
        (<HTMLInputElement>checkboxes[i]).checked = false;
      }
    }
  }

  /**
   * 壁リストに含まれていない壁があるかどうかを確認
   * @param area
   * @param wall
   * @param outer
   * @returns
   */
  findMissingWall = (area: any[], wall: any[], outer: any[]) => {
    let includedInArea = true;
    let includedInWall = true;
    let canInclude = false;
    const missing = [];
    for (let i = 0; i < outer.length; i += 1) {
      if (area.length > 0) includedInArea = marietta.webcad.WebCADGlobal.webcad2Dmanager.isSimilarLine(outer[i], area);
      if (wall.length > 0) includedInWall = marietta.webcad.WebCADGlobal.webcad2Dmanager.isSimilarLine(outer[i], wall);

      if (area.length > 0 && !includedInArea && !includedInWall) canInclude = true;
      else if (area.length === 0 && !includedInWall) canInclude = true;

      canInclude = !!(canInclude && !marietta.webcad.WebCADGlobal.webcad2Dmanager.isSimilarLine(outer[i], missing));

      if (canInclude) missing.push(outer[i]);
    }
    return missing;
  };

  reArrangePoints = (dotList) => {
    let p = dotList[0].clone();
    const list = [dotList[0].clone()];
    for (let i = 1; i < dotList.length; i += 1) {
      if (marietta.core.Point.distance(p, dotList[i]) > ALMOST_ZERO) {
        p = dotList[i];
        list.push(dotList[i].clone());
      }
    }
    const points = [list[0].clone()];
    for (let i = 0; i < list.length - 2; i += 1) {
      if (marietta.core.Point.distance(list[i], list[i + 1]) > ALMOST_ZERO) {
        if (!marietta.webcad.util.WebCADUtil.isPointOnSegment(list[i], list[i + 1], list[i + 2])) {
          points.push(list[i + 1]);
        }
      }
    }
    points.push(list[list.length - 1]);
    return points;
  };

  /**
   * ドラッグ中の制御
   */
  moveDrag = (e: MouseEvent & TouchEvent) => {
    e.preventDefault();
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      Stage.refreshStageMouse(<any>e);
      e.preventDefault();
      e.stopPropagation();
    }

    // pad スマホ用タッチ座標修正
    if (ua.isMobile || ua.isTablet) {
      if (e.touches.length >= 2) {
        return;
      }
    }
    this.endPoint = this.spt.localToGlobal(new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY));
    this.dotList.push(new marietta.core.Point(this.endPoint.x, this.endPoint.y));
    // console.log("pt", this.endPoint)
    this.path += `L ${this.endPoint.x} ${this.endPoint.y} `;
    this.sketch.setAttribute('d', this.path);
  };

  /**
   * 作成用モジュールなど削除する
   */
  clean() {
    document.querySelector('#layerGroup').removeEventListener('touchstart', this.startDrag);
    document.querySelector('#layerGroup').removeEventListener('touchmove', this.moveDrag);
    document.querySelector('#layerGroup').removeEventListener('mousedown', this.startDrag);
    document.querySelector('#layerGroup').removeEventListener('mousemove', this.moveDrag);

    if (this.dragImage) {
      this.dragImage.remove();
      this.dragImage = null;
    }
    marietta.webcad.WebCADGlobal.itemManager.itemController = null;
  }

  interrupt() {
    this.clean();
  }
}
